/* tslint:disable */
/* eslint-disable */
/**
 * Ory APIs
 * # Introduction Documentation for all public and administrative Ory APIs. Administrative APIs can only be accessed with a valid Personal Access Token. Public APIs are mostly used in browsers.  ## SDKs This document describes the APIs available in the Ory Network. The APIs are available as SDKs for the following languages:  | Language       | Download SDK                                                     | Documentation                                                                        | | -------------- | ---------------------------------------------------------------- | ------------------------------------------------------------------------------------ | | Dart           | [pub.dev](https://pub.dev/packages/ory_client)                   | [README](https://github.com/ory/sdk/blob/master/clients/client/dart/README.md)       | | .NET           | [nuget.org](https://www.nuget.org/packages/Ory.Client/)          | [README](https://github.com/ory/sdk/blob/master/clients/client/dotnet/README.md)     | | Elixir         | [hex.pm](https://hex.pm/packages/ory_client)                     | [README](https://github.com/ory/sdk/blob/master/clients/client/elixir/README.md)     | | Go             | [github.com](https://github.com/ory/client-go)                   | [README](https://github.com/ory/sdk/blob/master/clients/client/go/README.md)         | | Java           | [maven.org](https://search.maven.org/artifact/sh.ory/ory-client) | [README](https://github.com/ory/sdk/blob/master/clients/client/java/README.md)       | | JavaScript     | [npmjs.com](https://www.npmjs.com/package/@ory/client)           | [README](https://github.com/ory/sdk/blob/master/clients/client/typescript/README.md) | | JavaScript (With fetch) | [npmjs.com](https://www.npmjs.com/package/@ory/client-fetch)           | [README](https://github.com/ory/sdk/blob/master/clients/client/typescript-fetch/README.md) |  | PHP            | [packagist.org](https://packagist.org/packages/ory/client)       | [README](https://github.com/ory/sdk/blob/master/clients/client/php/README.md)        | | Python         | [pypi.org](https://pypi.org/project/ory-client/)                 | [README](https://github.com/ory/sdk/blob/master/clients/client/python/README.md)     | | Ruby           | [rubygems.org](https://rubygems.org/gems/ory-client)             | [README](https://github.com/ory/sdk/blob/master/clients/client/ruby/README.md)       | | Rust           | [crates.io](https://crates.io/crates/ory-client)                 | [README](https://github.com/ory/sdk/blob/master/clients/client/rust/README.md)       |
 *
 * The version of the OpenAPI document: v1.20.10
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CheckOplSyntaxResultFromJSON, CreateRelationshipBodyToJSON, RelationshipFromJSON, RelationshipNamespacesFromJSON, RelationshipPatchToJSON, RelationshipsFromJSON, } from '../models/index';
/**
 *
 */
export class RelationshipApi extends runtime.BaseAPI {
    /**
     * The OPL file is expected in the body of the request.
     * Check the syntax of an OPL file
     */
    checkOplSyntaxRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'text/plain';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/opl/syntax/check`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CheckOplSyntaxResultFromJSON(jsonValue));
        });
    }
    /**
     * The OPL file is expected in the body of the request.
     * Check the syntax of an OPL file
     */
    checkOplSyntax() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.checkOplSyntaxRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Use this endpoint to create a relationship.
     * Create a Relationship
     */
    createRelationshipRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/admin/relation-tuples`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CreateRelationshipBodyToJSON(requestParameters['createRelationshipBody']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipFromJSON(jsonValue));
        });
    }
    /**
     * Use this endpoint to create a relationship.
     * Create a Relationship
     */
    createRelationship() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.createRelationshipRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Use this endpoint to delete relationships
     * Delete Relationships
     */
    deleteRelationshipsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['namespace'] != null) {
                queryParameters['namespace'] = requestParameters['namespace'];
            }
            if (requestParameters['object'] != null) {
                queryParameters['object'] = requestParameters['object'];
            }
            if (requestParameters['relation'] != null) {
                queryParameters['relation'] = requestParameters['relation'];
            }
            if (requestParameters['subjectId'] != null) {
                queryParameters['subject_id'] = requestParameters['subjectId'];
            }
            if (requestParameters['subjectSetNamespace'] != null) {
                queryParameters['subject_set.namespace'] = requestParameters['subjectSetNamespace'];
            }
            if (requestParameters['subjectSetObject'] != null) {
                queryParameters['subject_set.object'] = requestParameters['subjectSetObject'];
            }
            if (requestParameters['subjectSetRelation'] != null) {
                queryParameters['subject_set.relation'] = requestParameters['subjectSetRelation'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/admin/relation-tuples`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Use this endpoint to delete relationships
     * Delete Relationships
     */
    deleteRelationships() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.deleteRelationshipsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get all relationships that match the query. Only the namespace field is required.
     * Query relationships
     */
    getRelationshipsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['pageToken'] != null) {
                queryParameters['page_token'] = requestParameters['pageToken'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['page_size'] = requestParameters['pageSize'];
            }
            if (requestParameters['namespace'] != null) {
                queryParameters['namespace'] = requestParameters['namespace'];
            }
            if (requestParameters['object'] != null) {
                queryParameters['object'] = requestParameters['object'];
            }
            if (requestParameters['relation'] != null) {
                queryParameters['relation'] = requestParameters['relation'];
            }
            if (requestParameters['subjectId'] != null) {
                queryParameters['subject_id'] = requestParameters['subjectId'];
            }
            if (requestParameters['subjectSetNamespace'] != null) {
                queryParameters['subject_set.namespace'] = requestParameters['subjectSetNamespace'];
            }
            if (requestParameters['subjectSetObject'] != null) {
                queryParameters['subject_set.object'] = requestParameters['subjectSetObject'];
            }
            if (requestParameters['subjectSetRelation'] != null) {
                queryParameters['subject_set.relation'] = requestParameters['subjectSetRelation'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/relation-tuples`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipsFromJSON(jsonValue));
        });
    }
    /**
     * Get all relationships that match the query. Only the namespace field is required.
     * Query relationships
     */
    getRelationships() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getRelationshipsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all namespaces
     * Query namespaces
     */
    listRelationshipNamespacesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/namespaces`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipNamespacesFromJSON(jsonValue));
        });
    }
    /**
     * Get all namespaces
     * Query namespaces
     */
    listRelationshipNamespaces(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRelationshipNamespacesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Use this endpoint to patch one or more relationships.
     * Patch Multiple Relationships
     */
    patchRelationshipsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("oryAccessToken", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/admin/relation-tuples`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['relationshipPatch'].map(RelationshipPatchToJSON),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Use this endpoint to patch one or more relationships.
     * Patch Multiple Relationships
     */
    patchRelationships() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            yield this.patchRelationshipsRaw(requestParameters, initOverrides);
        });
    }
}
